"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _TouModel = _interopRequireDefault(require("../model/TouModel"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
* Tou service.
* @module api/TouApi
* @version 1.1.3-alpha.1
*/
class TouApi {
  /**
  * Constructs a new TouApi. 
  * @alias module:api/TouApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  constructor(apiClient) {
    this.apiClient = apiClient || _ApiClient.default.instance;
  }

  /**
   * Get terms of use
   * Returns the terms of use as a json object
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/TouModel} and HTTP response
   */
  getTermsOfUseWithHttpInfo() {
    let postBody = null;
    let pathParams = {};
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = [];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = _TouModel.default;
    return this.apiClient.callApi('/api/v1/Tou', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
  }

  /**
   * Get terms of use
   * Returns the terms of use as a json object
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/TouModel}
   */
  getTermsOfUse() {
    return this.getTermsOfUseWithHttpInfo().then(function (response_and_data) {
      return response_and_data.data;
    });
  }

  /**
   * Sets the terms of use
   * Sets the terms of use and returns them as a json object
   * @param {Object} opts Optional parameters
   * @param {module:model/TouModel} opts.TouModel 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/TouModel} and HTTP response
   */
  setTermsOfUseWithHttpInfo(opts) {
    opts = opts || {};
    let postBody = opts['TouModel'];
    let pathParams = {};
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['Bearer'];
    let contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    let accepts = ['application/json'];
    let returnType = _TouModel.default;
    return this.apiClient.callApi('/api/v1/Tou', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
  }

  /**
   * Sets the terms of use
   * Sets the terms of use and returns them as a json object
   * @param {Object} opts Optional parameters
   * @param {module:model/TouModel} opts.TouModel 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/TouModel}
   */
  setTermsOfUse(opts) {
    return this.setTermsOfUseWithHttpInfo(opts).then(function (response_and_data) {
      return response_and_data.data;
    });
  }
}
exports.default = TouApi;